import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private metaService: Meta) {}

  public get xsrfHeader(): { [header: string]: string } {
    const token = this.metaService.getTag("name='csrf-token'").content;
    const headerName = this.metaService.getTag("name='csrf-token-header-name'").content;
    return { [headerName]: token };
  }

  public get xsrfFieldName(): string {
    return this.metaService.getTag("name='csrf-form-field-name'").content;
  }

  public get xsrfToken(): string {
    return this.metaService.getTag("name='csrf-token'").content;
  }
}
